/**
 * Must match `RELATED_RESOURCE_PARAM` and `btoaSafe` in
 * `@gonfalon/observability` so RelatedResourcePanel can decode the conversation.
 * Vega cannot import that package (observability already depends on vega).
 */
export const RELATED_RESOURCE_PARAM = 'related_resource';

function encodeRelatedResource(value: string): string {
  const encoded = btoa(String.fromCharCode(...new TextEncoder().encode(value)));
  return encoded.replace(/\+/g, '_PLUS_PLACEHOLDER_').replace(/ /g, '_SPACE_PLACEHOLDER_');
}

/**
 * Encode a conversation related-resource payload for the current page URL.
 *
 * RelatedResourcePanel reads `related_resource` and opens the conversation
 * panel in place — no navigation to traces. `gen_ai.conversation.id` on Vega
 * traces is the same id as the Vega conversation.
 *
 * Cold links omit timestamp so TraceProvider skips the origin-trace fetch and
 * `trace_conversation` auto-resolves the span window.
 */
export function encodeConversationRelatedResource(conversationId: string, timestamp?: string): string {
  return encodeRelatedResource(
    JSON.stringify({
      type: 'conversation',
      conversationId,
      ...(timestamp ? { timestamp } : {}),
    }),
  );
}
